import { useDispatch, useSelector } from "react-redux";

import { CircularProgress } from "@mui/material";

import Author from "./Author";

import AppPageShell from "./AppPageShell";

import KeyAvaileble from "./KeyAvaileble";

import { useEffect } from "react";

import { getGamesData, getProfile } from "../redux/asyncThunk/userActions";



export default function Dashbord() {

  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.user?.status);

  const user = useSelector((state) => state.user?.data?.user);

  const profile = useSelector((state) => state.user?.profile);



  useEffect(() => {

    if (user?.id) {

      dispatch(getGamesData({ id: user.id }));

      dispatch(getProfile({ id: user.id }));

    }

  }, [dispatch, user.id]);



  if (isLoading) {

    return (

      <div className="app-main">

        <div className="app-loading">

          <CircularProgress />

        </div>

      </div>

    );

  }



  return (

    <div className="app-main">

      <AppPageShell

        title="Рабочий стол"

        subtitle="Ваши интерактивные сценарии"

        headerExtra={<KeyAvaileble limit={profile?.limit} />}

      >

        <Author />

      </AppPageShell>

    </div>

  );

}

